import React, { useEffect } from "react";
import { CustomerEditFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Buttons, Inputs } from "components";
import { GENDER_TYPE_OPTION } from "utils/functions/customer";
import address from "utils/jsons/thailandAddress/address2.json";

const CustomerEditForm = ({ initialValues, onSubmit, onBack }) => {
  const schema = yup.object().shape({});

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });

  useEffect(() => {
    if (initialValues) {
      let params = initialValues;
      if (initialValues.province) {
        params.province = {
          label: initialValues.province,
          value: initialValues.province_code,
          name_th: initialValues.province,
          name_en: initialValues.province_en,
        };
      }
      reset(initialValues);
    }
  }, [initialValues, reset]);

  const handleFormSubmit = (data) => {
    const finalData = {};

    const formFields = [
      "first_name",
      "last_name",
      "gender",
      "province",
      "birthday",
      "email",
      "member_type",
    ];

    formFields.forEach((key) => {
      if (data[key] !== initialValues[key]) {
        finalData[key] = data[key];
      } else {
        finalData[key] = "";
      }
    });

    onSubmit(finalData);
  };

  const _renderProvinceOptions = () => {
    return address.reduce((result, data) => {
      result.push({
        ...data,
        label: data.name_th,
        value: String(data.id),
      });
      return result;
    }, []);
  };

  return (
    <CustomerEditFormStyled>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="form_section">
          <div className="form_title">Edit Customer Detail</div>
          <div className="input_row">
            <div className="f_left_col">Name</div>
            <div className="f_right_col">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    // placeholder={t('test')}
                    errors={errors.first_name?.message}
                  />
                )}
                name="first_name"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_row">
            <div className="f_left_col">Last Name</div>
            <div className="f_right_col">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    // placeholder={t('test')}
                    errors={errors.last_name?.message}
                  />
                )}
                name="last_name"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_row">
            <div className="f_left_col">เพศ</div>
            <div className="f_right_col">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Dropdown
                    {...field}
                    options={GENDER_TYPE_OPTION}
                    errors={errors.gender?.message}
                    // disabled={initialValues}
                  />
                )}
                name="gender"
                defaultValue=""
              />
            </div>
          </div>

          <div className="input_row">
            <div className="f_left_col">จังหวัด</div>
            <div className="f_right_col">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.InputMultiSelect
                    {...field}
                    options={_renderProvinceOptions()}
                    errors={errors.province?.message}
                    // disabled={initialValues}
                  />
                )}
                name="province"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_row">
            <div className="f_left_col">วันเกิด</div>
            <div className="f_right_col">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.DateTime
                    {...field}
                    errors={errors.birthday?.message}
                    showYearDropdown
                  />
                )}
                name="birthday"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_row">
            <div className="f_left_col">Email</div>
            <div className="f_right_col">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    // placeholder={t('test')}
                    errors={errors.email?.message}
                  />
                )}
                name="email"
                defaultValue=""
              />
            </div>
          </div>

          {/* <div className="input_row">
            <div className="f_left_col">Edit By</div>
            <div className="f_right_col">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Dropdown
                    {...field}
                    options={EDIT_BY_OPTION}
                    errors={errors.member_type?.message}
                    // disabled={initialValues}
                  />
                )}
                name="member_type"
                defaultValue="1"
              />
            </div>
          </div> */}
        </div>
        <div className="box_back">
          <div className="w150">
            <Buttons.BgStandard theme_gray label="Back" onClick={onBack} />
          </div>
          <div className="w150">
            <Buttons.BgStandard
              type="submit"
              label="Update"
              // disabled={initialValues && initialValues.is_center}
            />
          </div>
        </div>
      </form>
    </CustomerEditFormStyled>
  );
};

CustomerEditForm.propTypes = {};

export default CustomerEditForm;
